'use strict';

var util = require('./components/util');

$(document).ready(function () {
    if (util.isMobile() || $(window).width() < 992){
        $('.country-selector-indicator .select-location-below, .country-selector-indicator .icon-chevron-thin-right').click(function(){
            $([document.documentElement, document.body]).animate({
                scrollTop: $(".first-image-container")[0].scrollHeight - $('#menu')[0].scrollHeight
            }, 2000);
        });
    }else {
        $('.country-selector-indicator .select-location-below, .country-selector-indicator .icon-chevron-thin-right').click(function(){
            $([document.documentElement, document.body]).animate({
                scrollTop: $(".first-image-container")[0].scrollHeight - $('header')[0].scrollHeight
            }, 2000);
        });
    }

});